<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div class="content_head">
          <div class="content_head_ico">
            <img src="@/assets/images/worktable/titleguoducolor.png" alt=""/>
          </div>
          <div class="content_head_title">质量档案</div>
          <div class="content_head_button">
            <div class="content_head_seek">
              <el-select
                  @change="ssssss"
                  v-model="qualified2"
                  filterable
                  placeholder="选择仓房"
              >
                <el-option
                    v-for="item in qualifiedList2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="content_head_seek">
              <el-select
                  @change="ssssss"
                  v-model="qualified1"
                  filterable
                  placeholder="选择粮食品种"
              >
                <el-option
                    v-for="item in qualifiedList1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="content_head_seek">
              <el-select
                  @change="ssssss"
                  v-model="qualified3"
                  filterable
                  placeholder="选择质检类型"
              >
                <el-option
                    v-for="item in qualifiedList3"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="content_head_seek">
              <el-select
                  @change="ssssss"
                  v-model="year"
                  filterable
                  placeholder="选择入库年份"
              >
                <el-option
                    v-for="item in years"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="content_head_seek">
              <lk-button img="search.png"></lk-button>
            </div>
            <div class="content_head_seek">
              <lk-button img="export.png" type="lk_button_blue" @click="search">上传</lk-button>
            </div>
          </div>
        </div>
        <div class="Notice_list">
          <el-table
              :data="Notice"
              style="width: 100%"
          >
            <el-table-column
                prop="str1"
                label="编号"
                width="180"
                align="center">
            </el-table-column>
            <!-- <el-table-column
                prop="str2"
                label="库点"
                align="center">
            </el-table-column> -->
            <el-table-column
                prop="str3"
                label="仓房"
                align="center">
            </el-table-column>
            <el-table-column
                prop="str4"
                label="仓房类型"
                align="center">
            </el-table-column>
            <el-table-column
                prop="str5"
                label="粮权所属"
                align="center">
            </el-table-column>
            <el-table-column
                prop="str6"
                label="粮食品种"
                align="center">
            </el-table-column>
            <el-table-column
                prop="str7"
                label="粮食等级"
                align="center">
            </el-table-column>
            <el-table-column
                prop="str8"
                label="产地"
                align="center">
            </el-table-column>
            <el-table-column
                prop="str9"
                label="总仓容(kg)"
                align="center">
            </el-table-column>
            <el-table-column
                prop="str10"
                label="当前仓容(kg)"
                align="center">
            </el-table-column>
            <el-table-column
                prop="str11"
                label="最新入库时间"
                align="center">
            </el-table-column>
            <el-table-column
                prop="str12"
                label="最新质检时间"
                align="center">
            </el-table-column>
            <el-table-column
                label="操作"
                width="120"
                align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="buttonSwitch(scope.row.id,1)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging">
          <div class="block">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, prev, pager, next, jumper"
                :total="totalPage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapMutations} from "vuex";
import {httpToken} from "@/utils/http";
import qs from "qs";

export default {
  name: "Archives",
  data() {
    return {
      // 1为默认 2为详情页面
      detailshow: 1,
      showdata: {},
      Detailshowid: 1,
      queryCheckNumber: '',//查找
      Notice: [],
      currentPage: 1,
      totalPage: 10,
      qualifiedList: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "库房1",
          label: "库房1",
        },
        {
          value: "库房2",
          label: "库房2",
        },
      ],
      qualifiedList1: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "小麦",
          label: "小麦",
        },
        {
          value: "晚籼稻",
          label: "晚籼稻",
        },
      ],
      qualifiedList2: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "OP1",
          label: "OP1",
        },
        {
          value: "OP2",
          label: "OP2",
        },
        {
          value: "OP2",
          label: "OP2",
        },
      ],
      qualifiedList3: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "入库质检",
          label: "入库质检",
        },
        {
          value: "春季质检",
          label: "春季质检",
        },
        {
          value: "秋季质检",
          label: "秋季质检",
        },
        {
          value: "满仓质检",
          label: "满仓质检",
        },
        {
          value: "其他质检",
          label: "其他质检",
        },
      ],
      year: '2021',
      years: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "2021",
          label: "2021",
        },
        {
          value: "2020",
          label: "2020",
        },
        {
          value: "2019",
          label: "2019",
        },
      ],
      timepicker: "",
      qualified: "",
      qualified1: "",
      qualified2: "",
      qualified3: "",
      qualified4: "",
    };
  },
  methods: {
    ...mapMutations('Quality', ['setQualityState', 'setQualityId']),
    // 获取基本数据
    getDataList(page) {
      let paramData = [{column: 'unit', type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId},{column:'check_time', type: 'orderByDesc'}]
      httpToken({
        method: 'post',
        url: '/granary-quality-report/list',
        data: qs.stringify({
          page: page,
          paramData: JSON.stringify(paramData),
          rows: 10
        })
      }).then(res => {
        console.log(res)
      })
    },
    // 新增和详情和编辑按键
    buttonSwitch(id, state) {
      this.setQualityId(id);
      this.setQualityState(state);
      this.$emit('update:comName', 'ArchivesDetail')
    },
    ssssss(val) {
      console.log(val)
    },
    handleClick(val) {
      this.detailshow = 2;
      this.Detailshowid = val.str3;
      console.log(val);
    },
    alertShow(str, val, width) {
      console.log(str, val);
      this.showid = str;
      this.showwidth = width;
      this.showdata = val;
      this.showalert = true;
    },
    search() {
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(val);
      //   let json={column: "name",type: type.default.like, value: this.searchKey};
      //   json.value=this.searchKey;
      //   this.getdatalb(val,false,json)
    },
  },
  mounted() {
    this.getDataList(1)
  }
};
</script>
<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 0 20px;
}

.showbodymax {
  width: 100%;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #969696;

  .title {
    margin-bottom: 24px;
  }
}

.table_title {
  display: flex;
  margin-bottom: 20px;

  .table_title_left {

  }

  .table_title_right {
    margin-left: auto;
  }
}

.showbody_padding {
  padding: 30px 0;
}

.showbody_bor {
  border-top: 1px solid #eeeeee;
}

.showbody {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #969696;

  .inputbox_marginr {
    margin-right: 5%;
  }

  .inputbox {
    width: 30%;
    margin-bottom: 14px;

    .title {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #969696;
      margin-bottom: 14px;
    }

    .input {
      width: 100%;
      height: 36px;
      line-height: 36px;
      overflow: auto;
      white-space: nowrap;
      box-sizing: border-box;
      padding-left: 10px;
      background: #f4f7fd;
      border: 1px solid #dcdcdc;
    }

    .input::-webkit-scrollbar {
      display: none;
    }
  }
}

.content_head {
  display: flex;
  font-size: 18px;
  margin-bottom: 50px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0;
  }

  .content_head_button {
    max-width: 80%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      vertical-align: top;
      margin-left: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.Notice_alert {
  ::v-deep .el-table th {
    background-color: #f4f7fd;
  }

  ::v-deep .el-table thead {
    color: #969696;
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #f5f8ff;
  }

  ::v-deep .el-table thead {
    color: #000000;
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}
</style>
